import { GetAdminAssessmentsRequest, GetAdminAssessmentsResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../../services/core-api-service";

class AdminAssessmentsService {
    public async getAssessments(request: GetAdminAssessmentsRequest): Promise<GetAdminAssessmentsResult> {
        return api.admin.getAssessments(request)
    }
}

export const service = new AdminAssessmentsService()